const splitMifareIdAndAliasNumber = (text: string) => {
  return text?.match(/.{1,4}/g)?.join(' ');
};

export default splitMifareIdAndAliasNumber;
